<template>
  <div class="md-layout">
    <md-empty-state
      class="md-accent"
      md-icon="error"
      md-label="505"
      md-description="No se logro guardar la informacion, Intente nuevamente">
    </md-empty-state>
  </div>
</template>

<script>
import eventBus from '../bus'
  export default {
    name: 'Error', 
    mounted: function(){
        eventBus.$emit('isLoading', false);
    }
  }
</script>